// Catálogo canónico de módulos del sistema (coincide con los `module` keys en Layout.js).
// Se usa para los toggles de acceso por usuario que controla el Master.
export const APP_MODULES = [
  { key: 'dashboard', label: 'Dashboard' },
  { key: 'users', label: 'Usuarios' },
  { key: 'inventory', label: 'Inventario' },
  { key: 'clients', label: 'Clientes' },
  { key: 'sales', label: 'Ventas' },
  { key: 'purchases', label: 'Compras & Finanzas' },
  { key: 'dispatch', label: 'Despacho' },
  { key: 'finance', label: 'Finanzas' },
  { key: 'audit', label: 'Auditoría' },
  { key: 'payroll', label: 'Nómina' },
  { key: 'pricing_history', label: 'Histórico Precios' },
  { key: 'reports', label: 'Reportes' },
  { key: 'notifications', label: 'Notificaciones' },
];

export const COMPANY_TYPES = [
  { value: 'bienes', label: 'Bienes (productos físicos, descuentan stock)' },
  { value: 'servicios', label: 'Servicios (no descuentan stock)' },
  { value: 'mixta', label: 'Mixta (bienes y servicios)' },
];

export const COMPANY_TYPE_LABEL = {
  bienes: 'Bienes',
  servicios: 'Servicios',
  mixta: 'Mixta',
};
